import { MapPin, Navigation, Bus, Car, Footprints, ExternalLink } from "lucide-react";

export function MobilityBlock({ guide, notes, T, brand }) {
  const b = guide?.basic || {};
  const geo = guide?.geo;
  const address = b.address || [b.city, b.country].filter(Boolean).join(", ");
  const dest = encodeURIComponent(b.address || [b.city, b.country].filter(Boolean).join(", ") || guide?.name || "");
  const surface = { background: T.surface, borderColor: T.border };
  const label = { color: T.muted };
  const text = { color: T.text };
  const bodyCol = { color: T.dark ? T.muted : "#4B5563" };

  const mapsSearch = `https://www.google.com/maps/search/?api=1&query=${dest}`;
  const dir = (mode) => `https://www.google.com/maps/dir/?api=1&destination=${dest}&travelmode=${mode}`;

  const modes = [
    { label: "Mezzi pubblici", icon: Bus, href: dir("transit") },
    { label: "A piedi", icon: Footprints, href: dir("walking") },
    { label: "In auto", icon: Car, href: dir("driving") },
  ];

  return (
    <div className="space-y-4" data-testid="mobility-block">
      {geo?.lat != null && geo?.lng != null && (
        <div className="rounded-2xl overflow-hidden border" style={surface}>
          <iframe
            title="Mappa struttura"
            data-testid="mobility-map"
            className="w-full h-52 border-0"
            loading="lazy"
            src={`https://www.openstreetmap.org/export/embed.html?bbox=${geo.lng - 0.008}%2C${geo.lat - 0.006}%2C${geo.lng + 0.008}%2C${geo.lat + 0.006}&layer=mapnik&marker=${geo.lat}%2C${geo.lng}`}
          />
        </div>
      )}

      {address && (
        <div className="rounded-xl border p-3.5 flex items-start gap-3" style={surface}>
          <MapPin className="w-4 h-4 mt-0.5 shrink-0" style={{ color: brand }} />
          <div className="min-w-0">
            <p className="text-[11px] font-bold uppercase tracking-wide" style={label}>Indirizzo</p>
            <p className="text-[15px] mt-0.5" style={text}>{address}</p>
          </div>
        </div>
      )}

      <a href={mapsSearch} target="_blank" rel="noreferrer" data-testid="mobility-open-maps"
        className="flex items-center justify-center gap-2 rounded-xl py-3 font-semibold text-white active:scale-[0.98] transition-transform"
        style={{ background: brand }}>
        <Navigation className="w-4 h-4" /> Apri in Google Maps
      </a>

      <div>
        <p className="text-[13px] font-semibold mb-2" style={text}>Come raggiungerci</p>
        <div className="grid grid-cols-3 gap-2.5">
          {modes.map((m) => (
            <a key={m.label} href={m.href} target="_blank" rel="noreferrer" data-testid={`mobility-${m.label}`}
              className="flex flex-col items-center gap-1.5 rounded-2xl border p-3 active:scale-95 transition-transform" style={surface}>
              <div className="w-9 h-9 rounded-xl grid place-items-center" style={{ background: `${brand}22`, color: brand }}><m.icon className="w-4.5 h-4.5" /></div>
              <span className="text-[11px] font-semibold text-center leading-tight" style={text}>{m.label}</span>
            </a>
          ))}
        </div>
        <p className="text-[11px] mt-2 flex items-center gap-1" style={label}>
          <ExternalLink className="w-3 h-3" /> I percorsi si aprono in Google Maps con orari e indicazioni reali in tempo reale.
        </p>
      </div>

      {notes && (
        <div className="rounded-xl border p-3.5" style={surface}>
          <p className="text-[11px] font-bold uppercase tracking-wide" style={label}>Note dell'host</p>
          <p className="text-[15px] mt-1 leading-relaxed whitespace-pre-wrap" style={bodyCol}>{notes}</p>
        </div>
      )}
    </div>
  );
}
